export const actionListStyle = {
  wrapper: {
    '& .MuiMenu-paper': {
      border: 'solid 1px #000',
      borderColor: 'neutral.300',
      boxShadow: '0px 8px 12px rgba(9, 30, 66, 0.08)',
    },
  },
};
